import React from 'react';

const CompanyLogoFull = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="228.188"
      height="17.654"
      viewBox="0 0 228.188 17.654"
      {...props}
    >
      <title>The Mom Project</title>
      <g transform="translate(-390 -554)">
        <g transform="translate(390 554)">
          <path
            fill="currentColor"
            d="M216.532,14.588,210.15,6.614V20.993h1.4V10.524l4.986,6.359,4.986-6.359V20.993h1.47V6.54Z"
            transform="translate(-113.865 -3.618)"
          />
          <path
            fill="currentColor"
            d="M124.288,14.588,117.91,6.614V20.993h1.4V10.524l4.981,6.359,4.986-6.359V20.993h1.47V6.54Z"
            transform="translate(-64.408 -3.618)"
          />
          <path
            fill="currentColor"
            d="M129.028,18.227H130.3V1.38h-3.738l-4.986,6.577L116.593,1.38H112.85V18.227h1.35V2.577h1.294l6.081,7.751,6.155-7.751h1.3Z"
            transform="translate(-61.695 -0.851)"
          />
          <path
            fill="currentColor"
            d="M221.278,18.227h1.271V1.38h-3.738l-4.986,6.577L208.838,1.38H205.1V18.227h1.345V2.577h1.3l6.081,7.751,6.155-7.751h1.3Z"
            transform="translate(-111.157 -0.851)"
          />
          <path
            fill="currentColor"
            d="M170.291,17a5.209,5.209,0,1,1,.009,0h0m.023-11.717a6.494,6.494,0,1,0,6.494,6.494,6.494,6.494,0,0,0-6.494-6.494"
            transform="translate(-89.029 -2.942)"
          />
          <path
            fill="currentColor"
            d="M167.784,16.7A7.449,7.449,0,1,1,175.2,9.225v.056a7.449,7.449,0,0,1-7.421,7.422m0-16.132a8.674,8.674,0,1,0,8.673,8.674h0A8.7,8.7,0,0,0,167.784.57"
            transform="translate(-86.498 -0.417)"
          />
          <path
            fill="currentColor"
            d="M11.229,4.146v13.8H7.908V4.146H2.56V1.02H16.577V4.146Z"
            transform="translate(-2.56 -0.658)"
          />
          <path
            fill="currentColor"
            d="M50.217,17.95V10.928H42.838V17.95h-3.3V1.02h3.3v6.8h7.379V1.02h3.316V17.95Z"
            transform="translate(-22.388 -0.658)"
          />
          <path
            fill="currentColor"
            d="M79.82,17.95V1.02h10.6v3.1h-7.31V7.992h6.619v2.936H83.113v3.919h7.31v3.1Z"
            transform="translate(-43.985 -0.658)"
          />
          <path
            fill="currentColor"
            d="M260.993,8.723a2.365,2.365,0,0,0,2.653-2.412,2.382,2.382,0,0,0-2.653-2.435h-2.6V8.723Zm-2.625,2.843V17.94h-3.3V1H261.4c3.344,0,5.566,2.222,5.566,5.279s-2.217,5.279-5.566,5.279Z"
            transform="translate(-137.95 -0.647)"
          />
          <path
            fill="currentColor"
            d="M293.861,8.579a2.368,2.368,0,1,0,0-4.7h-2.695v4.7Zm-.955,2.839h-1.739V17.94H287.85V1h6.614a5.082,5.082,0,0,1,5.4,5.2,4.805,4.805,0,0,1-3.595,4.81L299.9,17.94h-3.678Z"
            transform="translate(-155.526 -0.647)"
          />
          <path
            fill="currentColor"
            d="M328.129,14.693a5.228,5.228,0,0,0,5.3-5.64,5.224,5.224,0,0,0-5.3-5.636c-2.63,0-5.274,1.814-5.274,5.636s2.672,5.64,5.274,5.64m0-14.453a8.56,8.56,0,0,1,8.743,8.841,8.707,8.707,0,1,1-17.412,0A8.533,8.533,0,0,1,328.129.24"
            transform="translate(-172.474 -0.24)"
          />
          <path
            fill="currentColor"
            d="M361.723,11.668H364.9v.979a2.291,2.291,0,1,0,4.564.074V1h3.293V12.712a5.413,5.413,0,0,1-5.257,5.565c-.086,0-.172,0-.258,0a5.208,5.208,0,0,1-5.543-5.515Z"
            transform="translate(-195.122 -0.647)"
          />
          <path
            fill="currentColor"
            d="M395.34,17.95V1.02h10.6v3.1h-7.31V7.992h6.614v2.936h-6.614v3.919h7.31v3.1Z"
            transform="translate(-213.159 -0.658)"
          />
          <path
            fill="currentColor"
            d="M424.8,9.081A8.551,8.551,0,0,1,433.423.24c4.68,0,7.092,2.867,7.76,5.613l-3.1.983a4.421,4.421,0,0,0-4.638-3.419c-2.533,0-5.2,1.818-5.2,5.664a5.2,5.2,0,0,0,5.25,5.566,4.7,4.7,0,0,0,4.754-3.46l3.08.928a7.7,7.7,0,0,1-7.834,5.752,8.44,8.44,0,0,1-8.669-8.813"
            transform="translate(-228.955 -0.24)"
          />
          <path
            fill="currentColor"
            d="M472.979,4.146v13.8h-3.321V4.146H464.31V1.02h14.017V4.146Z"
            transform="translate(-250.139 -0.658)"
          />
        </g>
      </g>
    </svg>
  );
};

export default CompanyLogoFull;
